import React from 'react';
import PropTypes from 'prop-types';
import {
  AccessibilityWrapper,
  ScrollableContainer,
  Icon,
} from 'legacy-packages/ft-cb';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { Link } from 'react-router';
import TableBody from '@material-ui/core/TableBody';
import Table from '@material-ui/core/Table';
import OnDemandLiveRegion from 'on-demand-live-region';
import PopOver from 'chameleon/ui-stack/ui/base/popover';

/**
 * Renders average popover for the current user
 */
const StudentAveragePopOver = (props) => {
  const {
    label,
    users = [],
    questions,
    resultsPathname,
    studentContext,
    partialScoreDisplay,
  } = props;
  const { studentId } = studentContext;
  const { reports = [] } =
    (studentId && users.find(({ id }) => id === studentId)) || users[0] || {};

  return (
    <div className="AveragePopOver StudentAveragePopOver d-flex flex-column justify-center">
      <PopOver
        showCloseButton
        onToggle={(state) => {
          if (state) {
            const liveRegion = new OnDemandLiveRegion();
            liveRegion.say('Popover opened');
          }
        }}
        className="average-popover"
        size="narrow"
        accessibility={{
          'aria-label': label,
          role: 'button',
          'data-test-tags-average-popover': true,
        }}
        trigger={<div data-test-popover-trigger>{label}</div>}
      >
        <ScrollableContainer className="pt-14" autoHeight autoHeightMax={240}>
          <Table data-test-resources-table className="average-popover-table">
            <TableBody
              className="average-popover-table-body"
              data-test-table-body
            >
              {questions.map((question) => {
                const {
                  id,
                  index: questionIndex,
                  learnosityItemReference,
                } = question;
                const resultsUrl = `${resultsPathname}${
                  !resultsPathname.endsWith('/') ? '/' : ''
                }`;
                const questionRoute = `${resultsUrl}performance/${id}`;
                const currentReport = (reports || []).find(
                  ({ itemKey }) => itemKey === learnosityItemReference,
                );
                if (!currentReport) {
                  return null;
                }
                const { isAnswered, isCorrect, itemKey } = currentReport;

                const questionText = `Question ${
                  Number.parseInt(questionIndex, 10) + 1
                }`;
                const questionState = isAnswered
                  ? isCorrect
                    ? ' correct'
                    : ' incorrect'
                  : '';

                return (
                  <TableRow
                    className="average-popover-table-row"
                    key={`resource-item-key-${id}`}
                  >
                    <TableCell className="cell user-name-cell">
                      <AccessibilityWrapper>
                        <Link
                          to={partialScoreDisplay ? '' : questionRoute}
                          role="link"
                          aria-label={questionText + questionState}
                        >
                          {questionText}
                        </Link>
                      </AccessibilityWrapper>
                    </TableCell>
                    <TableCell
                      key={`question-score-${itemKey}`}
                      className="cell icon-cell"
                    >
                      {(isAnswered &&
                        ((isCorrect && (
                          <Icon
                            className="correct-answer-icon"
                            name="correct"
                            size="1.2em"
                            title="Correct answer"
                          />
                        )) || (
                          <Icon
                            className="incorrect-answer-icon"
                            name="incorrect"
                            title="Incorrect answer"
                          />
                        ))) || <div className="no-answer-icon">&mdash;</div>}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </ScrollableContainer>
      </PopOver>
    </div>
  );
};

StudentAveragePopOver.propTypes = {
  /**
   * List of questions
   * */
  questions: PropTypes.array.isRequired,
  /**
   * Student context
   * */
  studentContext: PropTypes.shape({
    hasContext: PropTypes.bool,
    studentId: PropTypes.string,
  }),
};

StudentAveragePopOver.defaultProps = {
  studentContext: {
    hasContext: false,
    studentId: null,
  },
};

export default StudentAveragePopOver;
